import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import SEOHead from '../components/SEOHead';

export default function Terms() {
  const { t } = useLanguage();

  const sections = t.terms.sections || [];

  return (
    <div style={{ background: '#0C1220', minHeight: '100vh', paddingTop: 'var(--cjpa-nav-offset)' }}>
      <SEOHead page="terms" />
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: 'clamp(2rem, 4vw, 4rem) clamp(1rem, 3vw, 2rem)' }}>

        <div style={{ marginBottom: '4rem' }}>
          <h1 style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 'clamp(2.5rem, 5vw, 4rem)', color: '#E8ECF0', fontWeight: 300, marginBottom: '1rem' }}>
            {t.terms.title} <span style={{ color: '#D42B2B', fontStyle: 'italic' }}>{t.terms.titleHighlight}</span>
          </h1>
          <div style={{ color: '#94A3B8', fontSize: '0.85rem', letterSpacing: '0.05em' }}>
            {t.terms.lastUpdated}
          </div>
        </div>

        <p style={{ color: '#64748B', fontSize: '1rem', lineHeight: 1.9, marginBottom: '3rem' }}>
          {t.terms.intro}
        </p>

        {sections.map(([title, content]) => (
          <section key={title} style={{ marginBottom: '3rem' }}>
            <h2 style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: '1.8rem', color: '#D42B2B', fontWeight: 400, marginBottom: '1rem' }}>
              {title}
            </h2>
            <p style={{ color: '#94A3B8', fontSize: '0.95rem', lineHeight: 1.8 }}>
              {content}
            </p>
          </section>
        ))}

      </div>
    </div>
  );
}
